// import { useAppContextFeatures } from "../context/AppContext"

export const _operatorSymbols = {
    eq: "=",
    // startsWith: "_%",
    // endsWith: "%_",
    contains: "%",
    // containsOr: "%||",
    // anyOf: "where_in",
    // anyOfOr: "or_where_in",
    // excludeOf: "where_not_in",
    // excludeOfOr: "or_where_not_in",
    moreThanEq: ">=",
    // moreThanEqOr: ">=||",
    lessThanEq: "<=",
    // lessThanEqOr: "<=||",
    // notEq: "!=",
    // eqOr: "=||",
    // havingInOr: "or_having_in",
    isNull: "isNull",
    isNotNull: "isNotNull",
    // isNullOr: "null||"
}

export const _operatorDef = {
    eq: "eq",
    // startsWith: "startsWith",
    // endsWith: "endsWith",
    contains: "contains",
    // containsOr: "containsOr",
    // anyOf: "anyOf",
    // anyOfOr: "anyOfOr",
    // excludeOf: "excludeOf",
    // excludeOfOr: "excludeOfOr",
    moreThanEq: "moreThanEq",
    // moreThanEqOr: "moreThanEqOr",
    lessThanEq: "lessThanEq",
    // lessThanEqOr: "lessThanEqOr",
    // notEq: "notEq",
    // eqOr: "eqOr",
    // havingInOr: "havingInOr",
    isNull: "isNull",
    isNotNull: "isNotNull",
    // isNullOr: "isNullOr"
}

export function useServerParams() {

    // const { getLocationIds } = useAppContextFeatures();

    const getOperatorSymbol = (type) => {
        return _operatorSymbols[type]
    }

    const getListsUrl = (endpoint, props) => {

        let filters;

        const limit = props?.limit;
        const offset = props?.skip;
        const filterValue = props?.filterValue;
        const sortInfo = props?.sortInfo;
        // const dataTypes = props?.dataTypes ? props.dataTypes : [];

        if (filters === undefined) filters = [];

        if (filterValue) {
            for (let i = 0; i < filterValue.length; i += 1) {
                // if (filterValue[i]?.value ||
                //     filterValue[i].operator === _operatorDef.isNull ||
                //     filterValue[i].operator === _operatorDef.isNotNull ||
                //     filterValue[i].operator === _operatorDef.isNullOr
                // ) {

                let line = {
                    "field": filterValue[i]?.name,
                    "operator": getOperatorSymbol(filterValue[i].operator),
                    "value": filterValue[i]?.value
                }

                // if (filterValue[i]?.group) {
                //     line.group = filterValue[i].group
                // }

                filters.push(line)

                // }
            }
        }

        let sortfield = props?.defaultSortField ? props?.defaultSortField : 'id';
        let sortorder = props?.defaultSortOrder ? props?.defaultSortOrder : 'desc';

        if (sortInfo?.id) {
            sortfield = sortInfo?.id;
            sortorder = sortInfo?.dir === -1 ? 'desc' : 'asc'
        }

        let url = `${endpoint}?limit=${limit}&offset=${offset}&field=${sortfield}&sortby=${sortorder}`;

        if (filters && filters.length > 0) {
            url += `&filters=${JSON.stringify(filters)}`;
            // url += `&filters=${encodeURIComponent(filters)}`;
        } else {
            url += `&filters=[]`
        }

        // if (dataTypes.length) {
        //     url += `&datatypes=${JSON.stringify(dataTypes)}`
        //     // url += `&datatypes=${encodeURIComponent(dataTypes)}`
        // } else {
        //     url += `&datatypes=`
        // }

        // console.log('url', url)

        return url;

    }

    // const getListsPayload = (props) => {

    //     let filters;

    //     const limit = props?.limit;
    //     const offset = props?.skip;
    //     const filterValue = props?.filterValue;
    //     const sortInfo = props?.sortInfo;
    //     const dataTypes = props?.dataTypes ? props.dataTypes : [];

    //     if (filters === undefined) filters = [];

    //     if (filterValue) {
    //         for (let i = 0; i < filterValue.length; i += 1) {
    //             // if (filterValue[i]?.value ||
    //             //     filterValue[i].operator === _operatorDef.isNull ||
    //             //     filterValue[i].operator === _operatorDef.isNotNull ||
    //             //     filterValue[i].operator === _operatorDef.isNullOr
    //             // ) {

    //             let line = {
    //                 "fieldName": filterValue[i]?.name,
    //                 "fieldOperator": getOperatorSymbol(filterValue[i].operator),
    //                 "fieldValue": filterValue[i]?.value
    //             }

    //             // if (filterValue[i]?.group) {
    //             //     line.group = filterValue[i].group
    //             // }

    //             filters.push(line)

    //             // }
    //         }
    //     }

    //     let sortfield = props?.defaultSortField ? props?.defaultSortField : 'id';
    //     let sortorder = props?.defaultSortOrder ? props?.defaultSortOrder : 'desc';

    //     if (sortInfo?.id) {
    //         sortfield = sortInfo?.id;
    //         sortorder = sortInfo?.dir === -1 ? 'desc' : 'asc'
    //     }

    //     return {
    //         limit,
    //         offset,
    //         sortfield,
    //         sortby: sortorder,
    //         filters: JSON.stringify(filters)
    //     }

    // }

    // const getUrlWithDataTypes = (endpoint, dataTypesArray = []) => {
    //     return `${endpoint}?datatypes=${JSON.stringify(dataTypesArray)}`
    // }

    return {
        _operatorDef,
        getListsUrl,
        // getListsPayload,
        // getUrlWithDataTypes, 
        getOperatorSymbol
    }
}